import generateVersionHash from '@utils/generateVersionHash';
import axios from 'axios';
import  api  from './constants';
import mutations from './mutations';
import state from './state';
import { postApi } from '../../../lib/fetcher';

const historyRefund = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      const URL_API = api.GET_LIST_HISTORY_REFUND;

      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();

      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);

      const version = generateVersionHash(page.toString() + itemsPerPage.toString(), date);

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by: 'trx_datetime DESC',
        version
      });

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, URL_API, data, addConfig);

      if (responseData?.code === 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async getDetail(ctx, { date, id }) {
      const URL_API = api.GET_DETAIL_HISTORY_REFUND;

      ctx.commit('setLoading', true);

      const version = generateVersionHash(id, date);

      const data = JSON.stringify({
        id,
        version
      });

      const responseData = await postApi(ctx, URL_API, data);

      if (responseData?.code === 200) {
        ctx.commit('setDataDetail', { payload: responseData });

        return responseData?.data;
      }

      return null;
    },

  },
};

export default historyRefund;
